import { Controller } from "@hotwired/stimulus"

// Shows the wrapper when its turbo-frame loads content; hides on backdrop click.
export default class extends Controller {
  static targets = ["frame"]

  connect() {
    this.element.addEventListener("turbo:frame-load", () => this.show())
  }

  show() {
    if (this.frameTarget.children.length > 0) {
      this.element.classList.remove("hidden")
      this.element.classList.add("flex")
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.element) {
      this.close()
    }
  }

  close() {
    this.element.classList.add("hidden")
    this.element.classList.remove("flex")
    // Remove children via DOM API (avoids innerHTML with untrusted content)
    while (this.frameTarget.firstChild) {
      this.frameTarget.removeChild(this.frameTarget.firstChild)
    }
    this.frameTarget.removeAttribute("src")
  }
}
